import { useSelector } from "react-redux";
import { ReduxState } from "ra-core";
import { Box, Divider, Tab, Tabs} from "@mui/material";
import { FC } from "react";
import { Helmet } from 'react-helmet-async'
import { Link, matchPath, Redirect, useLocation } from "react-router-dom";
import { Content } from "@/components/content/Content";
import { OdResourcePageProps } from "@/types/resource";
import { useResourceRegister } from "@/utils/resourceRegister";
import withCompositeResource from "@/components/recource/CompositeResource";
import { useHasFeature } from "@/utils/useHasFeature";
import { MANAGE_SECUREAI_SETTINGS } from "@/constants";
import { getSettingsMenuDefaultRoute } from "@/authProvider/permissionMap";
import { useOdPermissions } from "@/authProvider/useOdPermissions";


const apprcodeResource = 'settings-secureai-app-register-code'
const mcprcodeResource = 'settings-secureai-mcpservers-register-code'


const SecureAISettings: FC<OdResourcePageProps> = (props) => {
  useResourceRegister({ name: apprcodeResource })
  useResourceRegister({ name: mcprcodeResource })

  // const ready = useSelector<ReduxState, boolean>(store => !!store.admin.resources[apprcodeResource])
  // return (
  //   ready ? <SecureAISettingsBody {...props} /> : null
  // )
  return (
    <SecureAISettingsBody {...props} />
  )
}

const tabSubRoutes = ['images', 'registration-code', 'info-types']

const SecureAISettingsBody: FC<OdResourcePageProps> = ({ 
  children, 
  options,
}) => {
  const location = useLocation()
  const { rest } = 
    matchPath<{rest:string}>(location.pathname, { path: '/settings/secureai/:rest'})?.params || {}
  const permissions = useOdPermissions()
  const hasSettingsPermit = permissions.has(MANAGE_SECUREAI_SETTINGS)
  const hasFeature = useHasFeature()
  const activeItem = rest ?? getSettingsMenuDefaultRoute("SecureAISettings", permissions)
  const isTabSubRoute = !activeItem || tabSubRoutes.indexOf(activeItem) > -1
  
  if (!hasFeature.OnDataSecureAI || !hasSettingsPermit) {
    return <Redirect to="/" />
  }

  return (
    <>
      <Helmet>
        <title>SecureAI Settings | OnData</title>
      </Helmet>
      {isTabSubRoute
        ? <Content pageName="SecureAI Settings" resourceName="SecureAI Settings" breadcrumbs={options?.breadcrumbs}>
            <Tabs scrollButtons="auto" variant="scrollable" indicatorColor="secondary" textColor="primary"
              value={activeItem ?? 'app'}
            >
              <Tab label="SecureAI Images" value="images" component={Link} to="/settings/secureai/images" sx={{ textTransform: 'unset' }} />
              <Tab label="Registration Code" value="registration-code" component={Link} to="/settings/secureai/registration-code" sx={{ textTransform: 'unset' }} />
              <Tab label="Info Types" value="info-types" component={Link} to="/settings/secureai/info-types" sx={{ textTransform: 'unset' }} />
            </Tabs>
            <Divider />
            <Box sx={{ mt: 3 }}>
              {children}
            </Box>
          </Content>
        : children}
    </>
  )
}

export const SecureAISettingsComposite = withCompositeResource(SecureAISettings);


